module.exports = __webpack_public_path__ + "static/media/myStrength-thumb.92d7e40a.png";